import React from 'react';
import { Container, Section } from '../ui/Section';
import { ButtonExternal } from '../ui/Button';
import { ScriptEyebrow } from '../ui/ScriptEyebrow';
import { Reveal } from '../motion/Reveal';
import { DoodleStar, DoodleUnderline } from '../brand/Doodles';
import { externalLinks } from '../../data/site';
export function FinalCta() {
  return <Section className="relative overflow-hidden bg-brand-blue py-16 sm:py-24" labelledBy="cta-heading" data-id="element-125" data-mp="2kgvbf6omw8y4">
      <DoodleStar className="pointer-events-none absolute left-6 top-8 h-10 w-10 sm:h-14 sm:w-14" color="var(--bcm-yellow)" data-id="element-126" data-mp="1woeu4ycq0kzv" />
      <Container className="max-w-3xl" data-id="element-127" data-mp="26gu8llot6rg0">
        <Reveal className="text-center" data-id="element-128" data-mp="26hnao9ctosrt">
          <div className="flex justify-center" data-id="element-129" data-mp="21pvsam3tltcr">
            <ScriptEyebrow data-id="element-130" data-mp="21o18xc8769as">There’s a place for you here</ScriptEyebrow>
          </div>
          <h2 id="cta-heading" className="mt-3 font-display text-4xl font-extrabold leading-[1.05] tracking-tight text-brand-navy sm:text-6xl" data-id="element-131" data-mp="1dyqf6ep9lf65">
            We’d love to meet you.
          </h2>
          <DoodleUnderline className="mx-auto mt-3 h-4 w-56" color="var(--bcm-pink)" data-id="element-132" data-mp="3n9wynsfu9f3r" />
          <p className="mx-auto mt-6 max-w-xl font-sans text-[17px] leading-relaxed text-ink" data-id="element-133" data-mp="3rc1m29fp1fhy">
            Tell us a little about yourself, ask a question, or let a BCM leader help you take the
            next step.
          </p>

          <div className="mt-8 flex justify-center" data-id="element-134" data-mp="34d576vq57tom">
            <ButtonExternal href={externalLinks.getConnectedForm} className="min-h-[56px] px-8 py-4 text-[17px] sm:text-lg" data-id="element-135" data-mp="34egjjjxnm9rc">
              Let’s Get Connected
            </ButtonExternal>
          </div>

          <div className="mt-6 flex flex-col items-center justify-center gap-3 sm:flex-row sm:gap-4" data-id="element-136" data-mp="3icwqnbzfi2a0">
            <ButtonExternal href={externalLinks.discord} variant="secondary" className="w-full sm:w-auto" data-id="element-137" data-mp="snl0iv2gjab5">
              Join the Discord
            </ButtonExternal>
            <ButtonExternal href={externalLinks.instagram} variant="secondary" className="w-full sm:w-auto" data-id="element-138" data-mp="xkuoe6a77dwv">
              Follow on Instagram
            </ButtonExternal>
            <ButtonExternal href={externalLinks.email} variant="secondary" className="w-full sm:w-auto" data-id="element-139" data-mp="2yfe2za8yyy0">
              Email UCF BCM
            </ButtonExternal>
          </div>
        </Reveal>
      </Container>
    </Section>;
}